import React from 'react';
import {
    LinearProgress,
    Table,
    TableBody,
    TableContainer,
} from '@mui/material';
import { useSupplementsList } from '../../../contextsProperty/ContextSupplements';
import useTranslate from '../../../../customHooks/useTranslate';
import Card from '../../../../muiComponents/Card';
import SupplementRow from './SupplementRow';
import { supplementsTableColumns } from '../../../../utils/supplements/supplementUtils';
import TableHeader from '../../../../Table/TableHeader';

const SupplementsTable = () => {
    const { items, isLoading, sortDir, sortedBy, sortByField, handleScroll } =
        useSupplementsList();
    const translate = useTranslate();

    return (
        <Card className='flex-column flex-grow min-height-0'>
            <TableContainer
                className=' flex-grow min-height-0 overflow-y-auto overflow-x-hidden'
                onScroll={handleScroll}
            >
                <Table stickyHeader size='small'>
                    <TableHeader
                        headerColumns={supplementsTableColumns}
                        sortedBy={sortedBy}
                        sortDir={sortDir}
                        sortByField={sortByField}
                        isLoading={isLoading}
                        selectable={false}
                    />
                    <TableBody>
                        {items.map(item => (
                            <SupplementRow key={item.Id} supplement={item} />
                        ))}
                    </TableBody>
                    {items.length === 0 && (
                        <caption className='no-results'>
                            {isLoading && <LinearProgress />}
                            {items.length === 0 &&
                                !isLoading &&
                                translate('no_results')}
                        </caption>
                    )}
                </Table>
            </TableContainer>
        </Card>
    );
};

export default SupplementsTable;
